/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Create the store with asynchronously loaded reducers
 */
import { configureStore, compose } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';

const initialState = {};

const store = configureStore({
  reducer: rootReducer,
  middleware: [],  // no middleware
  // middleware: getDefaultMiddleware =>
    /**
     * An array of Redux middleware to install. No middleware supplied for now, defaults to
     * the set of middleware returned by `getDefaultMiddleware()`.
     *  See https://redux-toolkit.js.org/api/configureStore#middleware
     */
    // getDefaultMiddleware({
      /**
       * serializableCheck: false, turns off warnings for usage of non-serializable data.
       * Most of the warnings come from passing localeData() in intlConfig and some data models.
       * See https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data
       */
     // serializableCheck: false,
    // }),
  preloadedState: initialState,
  devTools: process.env.NODE_ENV !== 'production'&&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose,
  /**
   * The store enhancers to apply.
   * No enhancers for now.
   * See https://redux-toolkit.js.org/api/configureStore#enhancers.
   */
  enhancers: [],
});

export default store;
